import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import './index.scss';

const SectionHeader = ({ hasExpanded = true, expanded, title, explanationText }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const [showExpanded, setShowExpanded] = useState(hasExpanded);

  useEffect(() => {
    setIsExpanded(expanded);
    setShowExpanded(hasExpanded);
  }, [expanded, hasExpanded]);

  if (showExpanded) {
    return (
      <div className="section-header">
        <div className="section-header__title" onClick={() => setIsExpanded(!isExpanded)}>
          <h4 className="section-title">{title}</h4>
          <div
            className={`section-header__expand-icon ${isExpanded ? 'chevron-up' : 'chevron-down'}`}
          ></div>
        </div>
        {}
        <div
          className={`section-header__explanation ${isExpanded ? 'explanation-open' : ''}`}
          data-testid="section-header-explanation"
        >
          <div data-testid="qualified-amount-value" className="explanation-text">
            {explanationText}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="section-header">
        <div className="section-header__title section-header__no-pointer">
          <h4 className="section-title">{title}</h4>
          <div className={`section-header__expand-icon`}></div>
        </div>
        {}
        <div
          className={`section-header__explanation explanation-open`}
          data-testid="section-header-explanation"
        >
          <div data-testid="qualified-amount-value" className="explanation-text">
            {explanationText}
          </div>
        </div>
      </div>
    );
  }
};

SectionHeader.propTypes = {
  expanded: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  explanationText: PropTypes.object.isRequired,
  hasExpanded: PropTypes.bool,
};

export default SectionHeader;
